import React, { useEffect, createRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'antd/dist/antd.css'
import Price from './types/Price'
import Availability from './types/Availability'
import OfficialDealer from './types/OfficialDealer'
import Delivery from './types/Delivery'
import Quantity from './types/Quantity'
import Brand from './types/Brand'
import isProd from '../../utils/constants/isProd'
import { selectFilter } from './filterSlice'
import { resetAll } from './filterSlice'
import TopParts from "../TopParts"
import localStorage from "../../utils/constants/localSorage"

const Filter = ({ isHide, filterHide, setFilterHide, setResultHeight }) => {
    const dispatch = useDispatch()
    const filter = useSelector(selectFilter)
    const classToggle = 'hide-filter'

    const refFilterbody = createRef()

    useEffect(() => {
        if (window.innerWidth <= 768) setFilterHide(classToggle)
    }, [setFilterHide])

    if (filterHide) document.body.classList.remove('modal-open')
    else document.body.classList.add('modal-open')

    const toggleShow = () => {
        if (filterHide.length) setFilterHide('')
        else setFilterHide(classToggle)
    }

    const filterClear = () => {
        dispatch(resetAll())
        toggleShow()
    }

    if(localStorage.filterHide === 'hide-filter') {
        isHide = true
    }

    useEffect(() => {
        if (isHide) setFilterHide(classToggle)
    }, [isHide, setFilterHide])
    useEffect(() => {
        const filterBody = document.querySelector('.search-filter .search-filter__body');
        const resultBlock = document.querySelector('.p-search__result');

        if (!filterBody || !resultBlock) return;

        const updatePosition = () => {
            const rect = resultBlock.getBoundingClientRect();
            const top = rect.top;
            const leftOffset = rect.left - 325;

            const filterHeight = filterBody.offsetHeight;
            const windowHeight = window.innerHeight;
            const bottomThreshold = 0;

            const dynamicStartFixY = (filterHeight <= windowHeight)
                ? 0
                : -(filterHeight - (windowHeight - bottomThreshold));

            const stopScrollY = -rect.height + filterHeight + bottomThreshold;

            if (top <= dynamicStartFixY && top > stopScrollY) {
                filterBody.style.position = 'fixed';
                filterBody.style.left = `${leftOffset}px`;
                filterBody.style.bottom = '';
                filterBody.style.top = filterHeight <= windowHeight
                    ? '20px'
                    : `${windowHeight - filterHeight - 50}px`;
                filterBody.style.transform = 'translate3d(0px, 0px, 0px)';

            } else if (top <= stopScrollY) {
                filterBody.style.position = 'relative';
                filterBody.style.left = '-17px';
                filterBody.style.bottom = '';
                filterBody.style.top = filterHeight <= windowHeight
                    ? '20px'
                    : `${windowHeight - filterHeight - 50}px`;
                filterBody.style.transform = `translate3d(0px, ${Math.abs(stopScrollY)}px, 0px)`;
            } else {
                filterBody.style.position = 'relative';
                filterBody.style.left = '-17px';
                filterBody.style.bottom = '';
                filterBody.style.top = '';
                filterBody.style.transform = 'translate3d(0px, 0px, 0px)';
            }

            requestAnimationFrame(updatePosition);
        };

        requestAnimationFrame(updatePosition);
    }, [])
    
    return (
        <div className={['search-filter', filterHide].join(' ')}>
            <div className="search-filter__header" onClick={toggleShow}>
                <div className="search-filter__header-name">Фильтр</div>
                <div className="search-filter__header-arrow"></div>
            </div>
            <div className="search-filter__body" ref={refFilterbody}>
                {!isProd && (
                    <div>
                        <div>Filter:</div>
                        <pre>
                            <code>{JSON.stringify(filter, null, 2)}</code>
                        </pre>
                    </div>
                )}
                {/*<div className="search-filter__prop currency">*/}
                {/*    <Currency />*/}
                {/*</div>*/}
                <div className="search-filter__prop top">
                    <TopParts />
                </div>
                <Price />
                <div className="search-filter__prop">
                    <Availability />
                    {false && <OfficialDealer />}
                </div>
                <Delivery />
                <Quantity />
                <Brand refFilterbody={refFilterbody} setResultHeight={setResultHeight} />
                <div className="search-filter__prop buttons">
                    <button className="search-filter__button cancel" onClick={filterClear}>
                        Отменить
                    </button>
                    <button className="search-filter__button apply" onClick={toggleShow}>
                        Применить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Filter
